import { useEffect, useId, useRef } from "react";
import Chart from "chart.js/auto";
import { ChartConfig } from "@app/types";

const BarChart = ({ config }: { config: ChartConfig }) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstance = useRef<Chart | null>(null);

  const id = useId();

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");

      if (ctx) {
        if (chartInstance.current) {
          chartInstance.current.destroy();
        }

        chartInstance.current = new Chart(ctx, config);
      }
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [config]);

  return (
    <div className="chart-container">
      <canvas id={id} ref={chartRef} />
    </div>
  );
};

export default BarChart;
